type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "text-center mx-auto max-w-2xl" : "max-w-2xl"}>
      {eyebrow && (
        <span className="inline-flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600 uppercase">
          <span className="w-6 h-px bg-primary-400"></span>
          {eyebrow}
        </span>
      )}
      <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-tight">
        {title}
      </h2>
      {desc && (
        <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>
      )}
    </div>
  );
}